var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import "./publicPath";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { BrowserRouter } from "react-router-dom";
import { WebgateProvider as _WebgateProvider } from "@xvia/webgate-connect";
import { WebgateAuthProvider } from "./infrastructure/providers/WebgateAuthProvider";
import { UiProvider, LayoutProvider } from "@uigovpe/components";
import { ToastProvider } from "./components/toast-provider";
import "primeicons/primeicons.css";
import "material-symbols/outlined.css";
import "./styles/globals.css";
var WebgateProvider = _WebgateProvider;
var baseName = window.__APP_BASE__ || "/";
var root = ReactDOM.createRoot(document.getElementById("root"));
root.render(_jsx(React.StrictMode, { children: _jsx(BrowserRouter, __assign({ basename: baseName }, { children: _jsx(WebgateProvider, __assign({ portalUrl: process.env.PORTAL_URL }, { children: _jsx(WebgateAuthProvider, { children: _jsx(LayoutProvider, { children: _jsx(UiProvider, { children: _jsx(ToastProvider, { children: _jsx(App, {}) }) }) }) }) })) })) }));
